export enum NatLanguage {
  Undefined = 0,
  Fr = 1,
  En = 2,
  Bi = 3,
}
